// extracted by mini-css-extract-plugin
module.exports = {"TFASubmissionError":"TfaForm_TFASubmissionError__tLIrm"};